import React from "react";
import arrowDown from "../src/images/arrow-down.svg";

const Transcript = () => {
  return (
    <div className="transcript-div">
      <h3>Transcript</h3>
      <div className="english">
        English
        <img src={arrowDown} alt="" />
      </div>
      <div className="transcript-text-div">
        <div className="transcript-text">
          <p>0.01</p>
          <p>
            First step. Open Facebook on your desktop or mobile device and
            locate "Marketplace" in the left-hand menu or at the top of the
            First step. Open Facebook on your desktop or mobile device and
            locate "Marketplace" in the left-hand menu or at the top of the{" "}
          </p>
        </div>
        <div className="transcript-text">
          <p>0.15</p>
          <p>
          First step. Open Facebook on your desktop or mobile device and locate "Marketplace" in the left-hand menu or at the top of the . Open Facebook on your desktop or mobile device and locate "Marketplace" in the left-ha{" "}
          </p>
        </div>
        <div className="transcript-text">
          <p>0.30</p>
          <p>
          First step. Open Facebook on your desktop or mobile device and locate "Marketplace" in the left-hand menu or at the top of the {" "}
          </p>
        </div>
        <div className="transcript-text">
          <p>1.00</p>
          <p>
            First step. Open Facebook on your desktop or mobile device and
            locate "Marketplace" in the left-hand menu or at the top of the
            First step. Open Facebook on your desktop or mobile device and
            locate "Marketplace" in the left-hand menu or at the top of the{" "}
          </p>
        </div>
        <div className="transcript-text">
          <p>0.01</p>
          <p>
            First step. Open Facebook on your desktop or mobile device and
            locate "Marketplace" in the left-hand menu or at the top of the
            First step. Open Facebook on your desktop or mobile device and
            locate "Marketplace" in the left-hand menu or at the top of the{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Transcript;
